import { get, put } from "../utils/request";

const requestList = {
  /* 计划评审 */
  getOrder: "/xxy/product/order/list",
  generatePlan: "/xxy/product/order/generatePlan",
  rejectPlan: "/xxy/product/order/toOperate",
  batchReview: "/xxy/product/order/batchToOrder",
  /* 生产任务 */
  getPlanList: "/xxy/product/plan/list",
  generateOrderId: "/xxy/product/order/generateOrderId", // default generateOrderId
  getOrderList: "/xxy/product/order/orderList", //get related orderList
  getBomList: "/xxy/basic/material/getInfo",
  savePlan: "/xxy/product/plan/save",
  removePlan: "/xxy/product/plan/remove",
  batchRemove: "/xxy/product/plan/batchRemove",
  toWork: "/xxy/product/plan/toWork",
  toSyncData: "/xxy/product/plan/sync",
  proofing: "/xxy/product/plan/proof",
  getMaster: "/xxy/basic/material/getInfo",
  listByOrderStatue: "/xxy/product/order/listByOrderStatue",
  listByOrderStatueFirstTen:'/xxy/product/order/listByOrderStatueFirstTen', //生产任务-新增-订单号
  saveByOrder: "/xxy/product/plan/saveByOrder",
  translateCard: "/xxy/product/plan/translateCard",
  getSupplier:'/xxy/basic/supplier/listAll',
  saveToEnd:"/xxy/product/plan/saveToEnd", //生产任务完结原因接口

  /* 生产报工 */
  getDevice: "/xxy/basic/device/getDeviceAndGroupInfo", //获取设备
  getWorkReport: "/xxy/product/work/listWorks",
  startUp: "/xxy/product/report/startup",
  getWorker: "/xxy/sys/user/userList",
  toComplete: "/xxy/product/report/toComplete",
  getMaterialByWork: "/xxy/product/work/toReport",
  // editReport:'/xxy/product/report/getInfo',
  updateReport: "/xxy/product/work/report",
  inspectReport: "/xxy/inspect/inspecresult/saveInspectResult",
  getInspectInfo: "/xxy/inspect/inspecschema/listSchemaByCateAndPro",
  /* 生产排程 */
  getGanttList: "/xxy/product/schedule/listScheData",
  toWorkSchedule: "/xxy/product/plan/toWork", //确认保存排程信息
  listByOrderOrPlan: "/xxy/product/work/listByOrderOrPlan",
  getScheData: "/xxy/product/work/listByMaterialOrTechline",
  getRouteList: "/xxy/basic/techline/getTechlineByMaterialId", //根据物料获取工艺路线
  autoWork: "/xxy/product/plan/autoWork", //自动生成排程信息

  /* 联合排程 */
  getModuleList: "/xxy/mould/mould/listAll",
  getUnionList: "/xxy/product/plan/listByMouldId",
  toUnionWork: "/xxy/product/plan/toUnionWork",
  perUnionWork: "/xxy/product/plan/preUnionWork",

  /* 工单管理 */
  getWorkList: "/xxy/product/work/list",
  saveWork: "/xxy/product/work/save",
  removeWork: "/xxy/product/work/remove",
  reportWork: "/xxy/product/work/report",
  listProcedure: "/xxy/basic/procedure/getInfo",
  getProcedureList:"/xxy/basic/procedure/list",
  generateWorkId: "/xxy/product/work/generateWorkId",
  proceduresByCate: "/xxy/basic/techline/getProcedureByMaterialId",
  deviceByProcedure: "/xxy/basic/techline/getDeviceByMaterialIdAndProcedureId",
  editWorkInfo: "/xxy/product/work/getInfo",

  toRecall: "/xxy/product/work/toRecall",
  toCompleteWork: "/xxy/product/work/toComplete",
  toComfirm: "/xxy/product/work/toConfirm",
  saveBylds:"/xxy/product/work/saveByIds", //批量回收和批量下发接口

  // 工单操作的质检：
  getIsInspect: "/xxy/device/configTask/lastInspect",

  /* 生产分析 */
  getProductStatic: "/xxy/product/report/producStatic",
  getMonthPlanCount: "/xxy/product/analy/getMonthPlanCount",
  getMonthWorkCount: "/xxy/product/analy/getMonthWorkCount",
  getDayWorkCont: "/xxy/product/analy/getDayWorkCount",
  getListWork: "/xxy/product/work/listWork",
  getDaySuccessCount: "/xxy/product/analy/getDaySuccessCount",
  getReportCountByDate: "/xxy/product/analy/getReportCountByDate",

  /*设备产况 */
  listEquipmentProduction: "/xxy/product/plan/listEquipmentProductionVO",
  listByPlanId: "/xxy/product/plan/listByPlanId",
  getDeviceAll: "/xxy/basic/device/getDeviceAndGroupInfo",

  /*计件报表*/
  getPieceworkList: "/xxy/product/report/listPieceReportVO",
  export: "/xxy/product/report/exportExcel",
  getClient:'/xxy/basic/client/listAll',
};

/* 测试接口的数据 */
export function gets(type) {
  return async function(data, options) {
    return await get(requestList[type], data, options);
  };
}
export function posts(type) {
  return async function(data, options) {
    return await put(requestList[type], data, options);
  };
}
// test
// export async function deviceByProcedure(data,options){
//   return await get(data,options);
// }
